import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ItemTitle from "./item-title";
import "../styles/section.scss";

const propTypes = {
  title: PropTypes.string.isRequired,
  editLink: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired
};

const defaultProps = {
  editLink: null
};

function Section(props) {
  const { title, editLink, children } = props;

  return (
    <section className="section py-3">
      <div className="section-header">
        <ItemTitle title={title} />
        {editLink && (
          <Link className="float-right edit-link" to={editLink}>
            <div className="edit-text">Edit</div>
          </Link>
        )}
      </div>
      <div>{children}</div>
    </section>
  );
}

Section.propTypes = propTypes;
Section.defaultProps = defaultProps;

export default Section;
